import * as React from "react";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import SelectAgent from "../../SelectAgent/SelectAgent";
import SelectFirm from "../../SelectFirm/SelectFirm";
import Input from "../../Input-new/Input";
import Dropdown from "../../Dropdown/Dropdown";
import Modal from "../../Modal/Modal";
import { addDaysSkippingWeekends, convertToWords, formatNumber, isAgentUser, numberToWords } from "../../../utils";
import moment from "moment";
import { fetchData, mutateData } from "../../Service/graphQlService";
import { GET_CONTACT_TEAM_LIST_QUERY, GET_CONTACT_VENDORS_LOI } from "../../Graphql/ContactsQueries/contactsQuery";
import Checkbox from "../../CheckboxNew";
import { INSERT_LOI_DATA } from "../../Graphql/Mutations/InsertLoiData";
import { CREATE_OR_UPDATE_CONTACTS_VENDORS } from './../../Graphql/ContactsMutations/allContactsMutation';

const ListingAgent = ({data, handleChangeDropdown, handleChangeInput, addNewItem, newAgent, newFirm, viewMode, deleted, userData}) => {

    const [loiData,setLoiData]= React.useState({
        buyer:'',
        price:'',
        earnestMoney:'$50,000',
        contractConsideration:'$100',
        dueDeligence:'30 Days',
        financing:'',
        additionalDeposit:'',
        close:'60 Days',   
        commission:'',
        expiration:addDaysSkippingWeekends(moment(), 3).format('YYYY-MM-DD'),
        titleCompany:'',
        agentInfo:{},
        dataloaded:false
    });
    const [titleCompany,setTitleCompany]= React.useState(" ");
    const [otherTitleCompany,setAddOtherTitleCompany]= React.useState("");
    const [loiModal,setLoiModal]= React.useState(false);
    const [ed,setEd]= React.useState(true);
    const [otherCompany,setOtherCompany]= React.useState(false);
    const [otherTitleCompanyData,setAddOtherTitleCompanyData]=React.useState({
        first_name:"",
        last_name:"",
        phone:'',
        company_name:''
    })
    const [vendorData,setVendorData]= React.useState([]);
const isAgentRestrictedUser =  isAgentUser(userData)

    React.useEffect(() => {
        if(titleCompany && titleCompany.toLowerCase()==='other'){
            setOtherCompany(true);
        }
      }, [titleCompany,otherCompany]); 

    React.useEffect(() => {
        //fetchTeamData()
        fetchVendors()
        const style = document.createElement('style');
        style.innerHTML = `
        @media print {
            @page {
                size: portrait;
            }
        }`;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    React.useEffect(()=>{
        if(!Object.keys(loiData.agentInfo).length && !loiData.dataloaded){
            fetchTeamData()
        }

    },[loiData.agentInfo,loiData.dataloaded])

    const fetchTeamData = async () => {
        let agentname = {}
        const findDataByLoggedinUser = await fetchData(GET_CONTACT_TEAM_LIST_QUERY, { type: "Team", filters: [{ email: userData.email, is_agent: 'y' }] })
        if (findDataByLoggedinUser.data.getContacts.success && findDataByLoggedinUser.data.getContacts.data.length) {
            agentname = findDataByLoggedinUser.data.getContacts.data[0]
        }
        else if (data.listing_agent_1) {
            const findDataByListingAgent = await fetchData(GET_CONTACT_TEAM_LIST_QUERY, { type: "Team", filters: [{ arcimedes_row_id: data.listing_agent_1 }] })
            if (findDataByListingAgent.data.getContacts.success && findDataByListingAgent.data.getContacts.data.length) {
                agentname = findDataByListingAgent.data.getContacts.data[0]
            }
        }
        
        setLoiData((prevLoiData) => ({ ...prevLoiData, agentInfo: agentname,dataloaded:true }));
    }

    const fetchVendors = async ()=>{
        const fetchVendorsData = await fetchData(GET_CONTACT_VENDORS_LOI, {filters: [{createdfromloi: true}],type: "Vendor"})

        if(fetchVendorsData.data.getContacts.data.length){
            const data= fetchVendorsData.data.getContacts.data.map(({
                first_name = '',
                last_name = '',
                company_city = '',
                company_state = '',
                company_name = '',
                company_address = '',
                phone = '',
                email = ''
              })=>({
                  VALUE:`${company_name ||''} -${company_address ||''}, ${company_city ||''}, ${company_state ||''} Attn: ${first_name ||''} ${last_name ||''} - P: ${phone ||''} E:${email ||''}`,
                  LABEL:`${company_name ||''} - ${company_city||''}, ${company_state||''} - ${first_name||''} ${last_name||''}`
            }))


            setVendorData(data)
        }
    }
    

    const handleLOI =(event)=>{
        event.preventDefault();
        setLoiModal(true)
    }

    const updateLOIForm=(key,value)=>{
        if (['price','earnestMoney','contractConsideration','additionalDeposit'].includes(key) && value.length) {
            let inputValue = value.replace(/[^0-9.]/g, '');

            if ((inputValue.match(/\./g) || []).length > 1) {
                return; // Exit if more than one decimal point
              }

            let numericValue = formatNumberWithCommas(inputValue);
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: numericValue
              }));

        }
        else if(['dueDeligence','close'].includes(key)){
            if (!isNaN(value) || value === '') {
                setLoiData((prevLoiData) => ({
                    ...prevLoiData,
                    [key]: value
                  }));
              }
        }
        else {
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: value
              }));

        }
    }
    const formatNumberWithCommas = (num) => {
        // Regular expression to format with commas, keeping decimal places intact
        const [integerPart, decimalPart] = num.split('.');
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
      };


    const handleBlur = (key,value,suffixType='',suffix=true) => {
        // Append 'days' when input field loses focus
        if (suffix && value && !value.endsWith(suffixType)) {
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: `${value} ${suffixType}`
            }))
        }
        if(!suffix && value && !value.startsWith(suffixType)) {
            const numericValue = parseFloat(value.replace(/[\$,]/g, ''));
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: `${suffixType}${numericValue.toLocaleString(undefined, {maximumFractionDigits: 2})}`
            }))
        }
      };

      const handleFocus = (key,value,suffixType='',suffix=true) => {
        // Remove 'days' when input field is focused
        if (suffix && value.endsWith(` ${suffixType}`)) {
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: value.replace(` ${suffixType}`, '')
            }))
        }

        if(!suffix && value && value.startsWith(suffixType)) {
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: value.replace(/^\$/, '')
            }))
        }
      };
    const updateTitleCompany=(data)=>{
    //    setLoiData((prevLoiData) => ({
    //     ...prevLoiData,
    //     titleCompany: data.titleCompany
    //   }));
      setTitleCompany(data.titleCompany);
    }

    const setNewVendorDetails = (key, value) => {
        setAddOtherTitleCompanyData((prevLoiData) => ({
            ...prevLoiData,
            [key]: value
        }))
    }
    const resetLOIForm=()=>{
        setLoiData({
            buyer:'',
            price:'',
            earnestMoney:'$50,000',
            contractConsideration:'$100',
            dueDeligence:'30 Days',
            financing:'',
            additionalDeposit:'$50,000',
            close:'60 Days',   
            commission:'',
            expiration:addDaysSkippingWeekends(moment(), 3).format('YYYY-MM-DD'),
            titleCompany:'',
            agentInfo:{},
            dataloaded:false
        });
        setTitleCompany(" ");
        setAddOtherTitleCompany("");
        setAddOtherTitleCompanyData({
            first_name:"",
            last_name:"",
            phone:'',
            company_name:''
        })
        setEd(true);
        setOtherCompany(false);
        setLoiModal(false);
    }
    const image1 ='https://strivenext.s3.us-east-1.amazonaws.com/LOI/LOI_new_Page_1.jpg'
    const image2 ="https://strivenext.s3.us-east-1.amazonaws.com/LOI/loi_second_page.jpg";
    const image4='https://strivenext.s3.us-east-1.amazonaws.com/LOI/LOI_PAGE_4_page-0001.jpg';
    const image5='https://strivenext.s3.us-east-1.amazonaws.com/LOI/LOI_PAGE_5_page-0001.jpg';
    const image3='https://strivenext.s3.us-east-1.amazonaws.com/LOI/loi_updated_3_page-0001.jpg';

    
    const displayCommission = () => {
        if (!loiData.commission) {
            return `Seller agrees to pay STRIVE a real estate commission per separate agreement`
        }
        return `Seller agrees to pay STRIVE a ${loiData.commission} commission at Close of Escrow`
    }

    const displayLOIBG = () => {
        if (loiData.financing && !loiData.additionalDeposit) {
            return image4
        }

        if (!loiData.financing && loiData.additionalDeposit) {
            return image5
        }
        return image2
    }

    const handleClassNames=(className)=>{

        if (!loiData.financing && loiData.additionalDeposit) {
            return className + "-5"
        }
        else if (loiData.financing && !loiData.additionalDeposit) {
            return className + "-4"
        }

        return className
    }

    const renderSecondPage = () => {
        if (!loiData.financing && !loiData.additionalDeposit) {
            return <div className="print-loi-second" style={{backgroundImage: `url(${image3})`}}>
            <img src={image3} height={0}/>
            <div className="close-date-third">
            {`Close of Escrow shall occur on or before ${convertToWords(loiData.close)} (${loiData.close ? loiData.close.replace(' Days','') : 0}) days after the`}
            <br /> {ed? `effective date of the formal Purchase and Sale Agreement` : ` expiration of the Feasibility Period`}
            </div>
            <div className="loi-commission-third">{displayCommission()}</div>
            <div className="expiration-date-third">{loiData.expiration ?( `This offer is valid until 5:00 pm CST on ${moment(loiData.expiration).format("MMMM DD, YYYY")}`):`This offer is valid until 5:00 pm CST on`}</div>
          </div>
        } else {
            return <div className="print-loi-second" style={{backgroundImage: `url(${displayLOIBG()})`}}>
            <img src={displayLOIBG()} height={0}/>
            {
                  loiData.financing && 
                 <div className={handleClassNames('loi-financing')}>{`Buyer shall have ${convertToWords(loiData.financing)} (${loiData.financing ? loiData.financing.toString().replace(' Days','') : 0}) days after the effective date of the formal`}
                      <br />Purchase and Sale Agreement to obtain a commitment for financing. Buyer
                      <br />shall apply for said financing and pay all applicable fees to lender within
                      <br />fourteen (14) days from the effective date of the formal Purchase and Sale
                      <br />Agreement
                  </div>
            }
            {
                  loiData.additionalDeposit && <div className={handleClassNames('additional-deposit')}>Upon expiration of the Feasibility Period, Buyer shall deposit an additional
                      <br />{`${numberToWords(formatNumber(loiData.additionalDeposit))} (${loiData.additionalDeposit}) with Escrow Company`}</div>
            }
            <div className={handleClassNames(`close-date`)}>
            {`Close of Escrow shall occur on or before ${convertToWords(loiData.close)} (${loiData.close ? loiData.close.replace(' Days','') : 0}) days after the`}
            <br /> {ed? `effective date of the formal Purchase and Sale Agreement` : ` expiration of the Feasibility Period`}
            </div>
            <div className={handleClassNames('loi-commission')}>{displayCommission()}</div>
            <div className={handleClassNames('expiration-date')}>{loiData.expiration ?( moment(loiData.expiration).format("MMMM DD, YYYY") ):""}</div>
          </div> 
        }
    };

    const handleCheckBox =()=>{
        setEd(!ed)
    }

    const addOtherTitleCompany=(e)=>{
        e.preventDefault();
         setOtherCompany(true);
       setTitleCompany("Other")
    }

    const undoOtherTitleCompany=(e)=>{
        e.preventDefault();
        setOtherCompany(false);
        setAddOtherTitleCompany("")
        setAddOtherTitleCompanyData({
            first_name:"",
            last_name:"",
            phone:'',
            company_name:''
        })
        setTitleCompany("")
    }

    const storeLoiData=(e)=>{
        e.preventDefault();
        const reqData = {
            buyer: loiData.buyer,
            earnest_money: loiData.earnestMoney,
            contract_consideration: loiData.contractConsideration,
            due_diligence: loiData.dueDeligence,
            financing: loiData.financing,
            additional_deposit: loiData.additionalDeposit,
            close: loiData.close,
            comission: loiData.commission,
            expiration: loiData.expiration,
            title_company: titleCompany,
            agent_id: `propertyId:${data.arcimedes_row_id},agentId:${loiData.agentInfo && Object.keys(loiData.agentInfo).length && loiData.agentInfo.arcimedes_row_id},price:${loiData.price}`
        }

        const vendorInput = {
            ...otherTitleCompanyData,
            createdfromloi: true,
            contact_type: ['Vendor']
        }

        if(!otherTitleCompanyData.first_name){
            vendorInput.first_name='fnu'
        }

        if(!otherTitleCompanyData.last_name){
            vendorInput.last_name='lnu'
        }

        mutateData(INSERT_LOI_DATA,{input:reqData}).then((response)=>{
            console.log(response);
        })

        if(otherCompany){
            mutateData(CREATE_OR_UPDATE_CONTACTS_VENDORS,  {input :vendorInput}).then((response)=>{
                console.log(response);
            })
        }
        

        print();
        
    }
    
    return (

        <React.Fragment>
            <div className="print-loi-first" style={{ backgroundImage: `url(${image1})` }}>
            <img src={image1} height={0}/>
            <div className="todaysDate">
                {moment().format("dddd, MMMM D, YYYY")}
            </div>
            <div className="agentInfo">
                {loiData && loiData.agentInfo && loiData.agentInfo.first_name && `${loiData.agentInfo.first_name} `} {loiData && loiData.agentInfo && loiData.agentInfo.last_name && `${loiData.agentInfo.last_name}`}
                <br/>{loiData && loiData.agentInfo && loiData.agentInfo.title && `${loiData.agentInfo.title}`}
                <br/>STRIVE
                <br/>17742 Preston Road
                <br/>Dallas, TX 75252
                <br/>{`Phone: ${loiData && loiData.agentInfo && loiData.agentInfo.phone && loiData.agentInfo.phone}`}
                <br/>Fax: 972-499-3483
                <br/>{`Email: ${loiData && loiData.agentInfo && loiData.agentInfo.email && loiData.agentInfo.email}`}
            </div>
            <div className="description">
            {`Re: ${data.name} - ${data.city}, ${data.state}`}
            <br/>
            <br/>
            {loiData && loiData.agentInfo && loiData.agentInfo.first_name && `Dear ${loiData.agentInfo.first_name.trim()},`}
            <br/>
            <br/>
            {`On behalf of ${loiData.buyer} and/or Assigns (“Buyer”), I am pleased to present to you this Non-Binding `}
            <br/>Letter of Intent based on the terms and conditions outlined below. This document is not a contract,
            <br/>but is intended to outline the basic business terms needed to negotiate, draft and enter into a Purchase and 
            <br/>Sale Agreement.
            </div>
            <div className="propertyInfo">
                {`${data.name} - ${data.address}, ${data.city}, ${data.state}`}
            </div>
            <div className="purchasePrice">
            {loiData.price && `${numberToWords(formatNumber(loiData.price))} (${loiData.price})`}
            </div>
                <div className="earnest-money">
                 {`Deposit of ${numberToWords(formatNumber(loiData.earnestMoney))} (${loiData.earnestMoney}) to be placed into escrow within`}
                 <br/>(3) days the effective date of the formal Purchase and Sale 
                </div>
                <div className="contract-consideration">
                    {`Buyer shall pay a ${loiData.contractConsideration} non-refundable contract consideration fee. This fee will be `}
                    <br />applicable towards the purchase price at close
                </div>
                <div className="title-company">
                {titleCompany!=="Other" ? titleCompany : (otherTitleCompanyData.company_name )}
                </div>
                {
                    loiData.dueDeligence && <div className="due-deligence">{`Buyer shall have ${convertToWords(loiData.dueDeligence)} (${loiData.dueDeligence ? loiData.dueDeligence.replace(' Days',''):0}) days after the effective date of the formal Purchase`}
                        <br />and Sale Agreement to conduct a feasibility study on this Property
                    </div>
                }
            </div> 
            {renderSecondPage()}
            <Modal className='loi-main' show={loiModal} onClose={() => resetLOIForm()}>
                <div className='loi-modal'>
                    <span className='green-title'> Create LOI </span>
                    <div className='close-button' onClick={() => resetLOIForm()} />
                </div>
                <div className='loi-modal-content' style={{ display: "grid", gap: "80px", gridTemplateColumns: "400px 400px 400px" }}>
                    <div>
                        <Input label='BUYER'
                            onChange={(event)=>updateLOIForm("buyer",event.target.value)}
                            value={loiData.buyer}
                        />
                        <Input
                            label='PRICE'
                            onChange={(event)=>updateLOIForm("price",event.target.value)}
                            value={loiData.price}
                            handleParentBlur={(key, value) => handleBlur('price',value,'$',false)}
                            handleInputFocus={()=>handleFocus('price',loiData.price,'$',false)}
                        />
                        <Input
                            label='EARNEST MONEY'
                            onChange={(event)=>updateLOIForm("earnestMoney",event.target.value)}
                            value={loiData.earnestMoney}
                            handleParentBlur={(key, value) => handleBlur('earnestMoney',value,'$',false)}
                            handleInputFocus={()=>handleFocus('earnestMoney',loiData.earnestMoney,'$',false)}
                        />
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            <Dropdown label='Title Company'
                                optionsType="title-companies"
                                customValues
                                className="title-company"
                                handleParentChange={updateTitleCompany}
                                valueKey="titleCompany"
                                value={titleCompany}
                                disabled={otherCompany}
                                optionLabelKey='LABEL'
                                optionKey={"VALUE"}
                                vendorData={vendorData}
                            />
                            <button className='button-new plus positive' disabled={isAgentRestrictedUser}  style={{ opacity: isAgentRestrictedUser ? 0.5 : 1,}} onClick={(e) => addOtherTitleCompany(e)}>+</button>
                        </div>
                        {/* {
                            otherCompany && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <div>
                                     <Input
                                        label='TITLE COMPANY NAME'
                                        onChange={(event) => setAddOtherTitleCompany(event.target.value)}
                                        value={otherTitleCompany}
                                        className="title-company-other"
                                    />
                                </div>
                                
                                <button className='button-new negative' onClick={(e) => undoOtherTitleCompany(e)}>Remove</button>
                            </div>
                        } */}
                    </div>
                    <div >
                    <Input
                            // valueType="integer"
                            label='DUE DILIGENCE'
                            onChange={(event) => updateLOIForm("dueDeligence", event.target.value)}
                            value={loiData.dueDeligence}
                            handleParentBlur={(key, value) => handleBlur('dueDeligence',value,'Days')}
                            handleInputFocus={()=>handleFocus('dueDeligence',loiData.dueDeligence,'Days')}
                        />
                        <div className="close-section">
                                CLOSE
                            <Checkbox
                                text="ED"
                                type="checkable"
                                isSelected={ed}
                                handleClick={handleCheckBox}
                                name="ED"
                            />
                             <Checkbox
                                text="DD"
                                type="checkable"
                                isSelected={!ed}
                                handleClick={handleCheckBox}
                                name="DD"
                            />
                        </div>
                        <Input onChange={(event) => updateLOIForm("close", event.target.value)}
                            value={loiData.close}
                            handleParentBlur={(key, value) => handleBlur('close', value, 'Days')}
                            handleInputFocus={() => handleFocus('close', loiData.close, 'Days')}
                        />
                        <Input label='Expiration'
                            // valueType="iso-date"
                            type="date"
                            format="mm/dd/yyyy"
                            onChange={(event)=>updateLOIForm("expiration",event.target.value)}
                            value={loiData.expiration}
                        />
                    </div>
                    <div>
                    <Input label='Commission'
                            value={loiData.commission}
                            onChange={(event)=>updateLOIForm("commission",event.target.value)}
                            handleParentBlur={(key, value) => handleBlur('commission',value,'%')}
                            handleInputFocus={()=>handleFocus('commission',loiData.commission,'%')}
                        />
                        <Input
                            name='contractConsideration'
                            label='CONTRACT CONSIDERATION'
                            onChange={(event)=>updateLOIForm("contractConsideration",event.target.value)}
                            value={loiData.contractConsideration}
                            handleParentBlur={(key, value) => handleBlur('contractConsideration',value,'$',false)}
                            handleInputFocus={()=>handleFocus('contractConsideration',loiData.contractConsideration,'$',false)}
                        />
                        <Input
                            onChange={(event)=>updateLOIForm("financing",event.target.value)}
                            value={loiData.financing}
                            handleParentBlur={(key, value) => handleBlur('financing',value,'Days')}
                            handleInputFocus={()=>handleFocus('financing',loiData.financing,'Days')}
                            label='Financing'
                        />
                        <Input
                            label='Additional Deposit'
                            onChange={(event)=>updateLOIForm("additionalDeposit",event.target.value)}
                            value={loiData.additionalDeposit}
                            handleParentBlur={(key, value) => handleBlur('additionalDeposit',value,'$',false)}
                            handleInputFocus={()=>handleFocus('additionalDeposit',loiData.additionalDeposit,'$',false)}
                        />
                    </div>
                </div>
                <div>
                {
                            otherCompany && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <div style={{display:'flex',gap:'80px'}}>
                                     <Input
                                        label='FIRST NAME'
                                        onChange={(event) => setNewVendorDetails('first_name',event.target.value)}
                                        value={otherTitleCompanyData.first_name}
                                        className="title-company-other"
                                        required={true}
                                    />
                                    <Input
                                        label='LAST NAME'
                                        onChange={(event) => setNewVendorDetails('last_name',event.target.value)}
                                        value={otherTitleCompanyData.last_name}
                                        className="title-company-other"
                                        required={true}
                                    />
                                    <Input
                                        label='PHONE NUMBER'
                                        onChange={(event) => setNewVendorDetails('phone',event.target.value)}
                                        value={otherTitleCompanyData.phone}
                                        className="title-company-other"
                                        required={true}
                                        valueType='phone'
                                    />
                                    <Input
                                        label='TITLE COMPANY NAME'
                                        onChange={(event) => setNewVendorDetails('company_name',event.target.value)}
                                        value={otherTitleCompanyData.company_name}
                                        className="title-company-other"
                                        required={true}
                                    />
                                </div>
                                
                                <button className='button-new negative' onClick={(e) => undoOtherTitleCompany(e)}>Remove</button>
                            </div>
                        }
                </div>
                <div className="modal-buttons" style={{ display: 'flex', justifyContent: "flex-end", gap: "20px" }}>
                <button className='button-new positive'   style={{ opacity: isAgentRestrictedUser ? 0.5 : 1,}} disabled={isAgentRestrictedUser} onClick={(e) => {storeLoiData(e)}}>Submit</button>
                <button className='button-new negative'  style={{ opacity: isAgentRestrictedUser ? 0.5 : 1,}} disabled={isAgentRestrictedUser} onClick={() => resetLOIForm()}>Cancel</button>
                </div>
            </Modal>
            <div className="Listing-agent">
                <div className="Listing-agent_column">
                    <SelectTeam
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.listing_agent_1}
                        valueKey="listing_agent_1"
                        percentKey="listing_agent_1_percent"
                        label="Listing Agent 1"
                        data={data}
                        hasAgentPercent={true}
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <SelectTeam
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.listing_agent_2}
                        valueKey="listing_agent_2"
                        percentKey="listing_agent_2_percent"
                        label="Listing Agent 2"
                        data={data}
                        hasAgentPercent={true}
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <SelectTeam
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.listing_agent_3}
                        valueKey="listing_agent_3"
                        percentKey="listing_agent_3_percent"
                        label="Listing Agent 3"
                        data={data}
                        hasAgentPercent={true}
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <SelectAgent
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.listing_agent_4}
                        valueKey="listing_agent_4"
                        percentKey="listing_agent_4_percent"
                        label="Outside Agent"
                        data={data}
                        hasAgentPercent={true}
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        withAddNew={true}
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newAgent={newAgent}
                    />
                    <SelectFirm
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.listing_agent_4_firm}
                        valueKey="listing_agent_4_firm"
                        label="Listing Agent Company"
                        data={data}
                        handleParentChange={handleChangeDropdown}
                        withAddNew={true}
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newFirm={newFirm}
                    />
                </div>
                <div className="Listing-agent_column">
                    <div className="Listing-agent_column_item">
                        <button className="Listing-agent_column_item_loi button-new text" style={{ color: '#90C54B' }}  onClick={(e) => handleLOI(e)}>Letter of Intent (LOI)</button>
                    </div>     
                    <div className="Listing-agent_column_item"></div>
                    <div className="Listing-agent_column_item"></div>                    
                    <SelectAgent
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.referring_listing_agent}
                        valueKey="referring_listing_agent"
                        percentKey="referring_listing_agent_percent"
                        label="Referring Agent"
                        data={data}
                        hasAgentPercent={true}
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        withAddNew={true}
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newAgent={newAgent}
                    />                                    
                    <SelectFirm
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.referring_listing_agent_firm}
                        valueKey="referring_listing_agent_firm"
                        label="Referring Agent Company"
                        data={data}
                        handleParentChange={handleChangeDropdown}
                        withAddNew={true}
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newFirm={newFirm}
                    />                    
            </div> 
            </div>
        </React.Fragment>
        
    );
};

export default ListingAgent;